export interface LeafFilters {
  text: string;
  required: boolean;
  perStore: boolean;
  matchAll: boolean;
}

interface Groupable {
  folder: string;
  leaf: string;
  label?: string | null;
  helpText?: string | null;
  description?: string | null;
  alwaysRequired: boolean;
  perStore: boolean;
}

export const groupLeaves = <T extends Groupable>(
  leaves: T[],
  { text, required, perStore, matchAll }: LeafFilters,
): { folder: string; leaves: T[] }[] => {
  const needle = text.trim().toLowerCase();
  const flags = (l: T) => [
    ...(required ? [l.alwaysRequired] : []),
    ...(perStore ? [l.perStore] : []),
  ];
  const groups = new Map<string, T[]>();
  for (const l of leaves) {
    const on = flags(l);
    const flagOk =
      on.length === 0 || (matchAll ? on.every(Boolean) : on.some(Boolean));
    const textOk = [l.leaf, l.label, l.helpText, l.description].some((v) =>
      (v ?? "").toLowerCase().includes(needle),
    );
    if (flagOk && textOk)
      groups.set(l.folder, [...(groups.get(l.folder) ?? []), l]);
  }
  return [...groups.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([folder, rows]) => ({ folder, leaves: rows }));
};
